// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import headerAccountWarehouseInfoSharedStyles from "@pace/App/SharedStyles/headerAccountWarehouseInfoSharedStyles";
import { headerWarehouseAddress } from "@pace/App/Widgets/Common/HeaderWarehouseAddress";
import { FormInputWrapper } from "@pace/MobiusOverrides/FormField";
import { color } from "@pace/XDL/Utilities";
import { css } from "styled-components";

headerWarehouseAddress.titleTypography = headerAccountWarehouseInfoSharedStyles.titleTypography;
headerWarehouseAddress.titleLabelTypography = headerAccountWarehouseInfoSharedStyles.titleLabelTypography;
headerWarehouseAddress.titleIcon = headerAccountWarehouseInfoSharedStyles.titleIcon;
headerWarehouseAddress.branchWrapper = headerAccountWarehouseInfoSharedStyles.wrapper;
headerWarehouseAddress.titleClickable = headerAccountWarehouseInfoSharedStyles.titleClickable;
headerWarehouseAddress.warehousesDynamicDropdown = {
    labelProps: {
        css: css`
            display: none;
            &&& + ${FormInputWrapper} {
                margin-top: 0;
            }
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            &&&& input {
                &, &:hover:not(:disabled), &:focus:not(:disabled) {
                    border: 0;
                    padding: 0;
                    color: ${color("text")};
                }
            }
        `,
        inputSelect: css`
            height: 30px;
            background: transparent;
            padding: 0;
            box-shadow: none;
            & ~ ${IconWrapper} {
                display: none;
            }
        `,
        selectedText: css`
            padding: 7px 0 0;
            color: ${color("text.main")};
            font-size: 12px;
            border-bottom: 1px solid ${color("common.border")};
            width: calc(100% - 16px);
        `,
    }
};